/**
 * 赠品相关配置
 * 1. 赠品名拼接公共方法。
 * 2. 获取特殊分销商的赠品折扣提示
 */

import { isEmpty, getName, isSameProductName } from '..';
import { formatPriceThousands } from './price.config';

/**
 * 特殊分销商赠品配置
 * @param {String} promoCode:分销码
 * @param {Array} pid:产品id
 * @param {String} tip:展示信息，展示在名称排列之前
 * @param {Array} enableCountry 选填，国家码，没有配置表示所有地区都可以
 * @param {Array} cid:选填，套餐id，没有配置cid表示所有套餐都可以
 */
const specialResellerGiftsConfig = [
  {
    promoCode: 'INR5IM7',
    enableCountry: ['CN'],
    pid: [225],
    tip: 'product.page.INR5IM7_affiliate_gift_tips',
  },
];

/**
 * 分销商赠品金额阈值过滤，小于给定阈值的不展示赠品价值金额 - for子莹
 */
const GiftsPriceThreshold = {
  USD: 5,
  HKD: 38,
  AUD: 9,
  JPY: 1000,
  EUR: 6,
  GBP: 5,
  CAD: 8,
  CNY: 29,
  KRW: 7000,
  TWD: 159,
  SGD: 8,
};

/**
 * 获取特殊分销商赠品提示(展示在营销模块)
 * @param {Number} pid
 * @param {Number} cid
 * @param {object} LANG
 * @param {string} countryCode
 * @param {object} promoCode
 */
export const getSpecialResellerGiftsTip = (values = {}) => {
  const { pid, cid, LANG, countryCode, promoCode } = values;
  const item =
    specialResellerGiftsConfig.filter((config) => {
      if (
        config.pid.includes(pid) &&
        config.promoCode === promoCode &&
        (config.cid ? config.cid.includes(cid) : true) &&
        (config.countryCode ? config.countryCode.includes(countryCode) : true)
      ) {
        return true;
      }
      return false;
    })[0] ?? {};

  return isEmpty(item)
    ? LANG['product.page.info_affiliate_gift_tips']
    : item.tip?.includes('.')
    ? LANG[item.tip]
    : item.tip;
};

/**
 * 赠品名拼接公共方法。
 * @param {*} gifts 数据类型同productMobx-productGifts
 * @param {string} type resellerGift | activityGift
 * @param {object} values LANG , country , 特殊分销商查询参数
 * @param {object} country 格式化价格需要
 */
export const getGiftsIntro = (gifts, type, values = {}) => {
  const { LANG, country } = values;
  const isResellerGift = type === 'resellerGift';

  try {
    if (!isEmpty(gifts)) {
      const _gifts = gifts.map((item) => {
        const pName = getName(item.product.name, 'split');
        const cName = getName(item.commodityName, 'split');
        const name = isSameProductName(pName, cName) ? pName : `${pName}(${cName})`;

        return {
          name,
          price: item?.originPrice?.amount || item?.origin_price?.amount || item.price.amount,
          number: item.number,
        };
      });

      const giftTip = isResellerGift
        ? getSpecialResellerGiftsTip(values)
        : LANG['product.page.info_activity_gift_tips'];
      const name = _gifts.map(
        (gift, index) =>
          `${index !== 0 ? (country.X_Language === 'de_de' ? ' + ' : ' , ') : ''}${gift.name}${
            gift.number > 1 ? ' × ' + gift.number : ''
          }`
      );
      const value = _gifts.reduce((total, item) => (total += item.price * item.number), 0);
      let valueLang = LANG['common.label.value'].replace(
        'xxx',
        formatPriceThousands({
          price: value,
          country,
        })
      );

      // 如果分销赠品金额小于阈值，不展示价值文案
      if (
        isResellerGift &&
        value &&
        GiftsPriceThreshold[country.currency] &&
        value <= GiftsPriceThreshold[country.currency]
      ) {
        valueLang = '.';
        if (['zh_CN', 'zh_TW', 'ja_JP'].includes(country.language)) {
          valueLang = '。';
        }
      }

      return (
        <div>
          <span>
            {giftTip.split('&&')[0]}
            {name}
            {valueLang}
          </span>
          {giftTip.split('&&')[1]}
          {isResellerGift && ` ${LANG['product.reseller.storeOnly']}`}
          {isResellerGift && ` (${LANG['product.reseller.giftTips']?.replace('*', '')?.trim()})`}
        </div>
      );
    }
    return null;
  } catch (e) {
    console.error('赠品显示失败', e);
    return null;
  }
};
